import React, { useState } from 'react';

function SurveyStepTwentyOne({ formData, onNext }) {
    const [resourceRating, setResourceRating] = useState(formData.resourceRating || '');
    const [resourceComments, setResourceComments] = useState(formData.resourceComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!resourceRating) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ resourceRating, resourceComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 5: Employee Experience</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                Do you feel you have the resources you need to succeed in your role? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`resource-rating-${option}`}
                            name="resourceRating"
                            value={option}
                            checked={resourceRating === option}
                            onChange={() => setResourceRating(option)}
                        />
                        <label htmlFor={`resource-rating-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={resourceComments}
                    onChange={(e) => setResourceComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!resourceRating}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepTwentyOne;
